import {z} from "zod";
import {SALES_DETAIL_TYPE_KEY_TYPE} from "../common/enum";

/**
 * @name 목표관리 Detail 버튼 상태
 * 최초등록 가능
 * 추가등록 가능
 * 수정
 */
const SALES_DETAIL_FORM_STATUS_TYPE_ENUM = ["REGISTER", "ADD_REGISTER", "MODIFY", "DISABLE"] as const;
export const SALES_DETAIL_FORM_STATUS_TYPE = z.enum(SALES_DETAIL_FORM_STATUS_TYPE_ENUM);
export type SALES_DETAIL_FORM_STATUS_TYPE = z.infer<typeof SALES_DETAIL_FORM_STATUS_TYPE>;

export const salesYearlyFormSchema = z.object({
	id: z.string().nullable(),
	type: SALES_DETAIL_TYPE_KEY_TYPE,
	content: z.string(),
	status: SALES_DETAIL_FORM_STATUS_TYPE
});

export type SalesYearlyFormModel = z.infer<typeof salesYearlyFormSchema>;
